import React, { useState, useEffect, useRef } from 'react';
import { updatePolicy } from '../../services/policyAPIs';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  IconButton
} from '@mui/material';
import EditorConvertToHTML  from '../../utils/TextEditor';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { CloudUpload,  Delete } from '@mui/icons-material';

const UpdatePolicyForm = ({pTitle, type}) => {
  console.log(localStorage.getItem('token'));
  console.log(localStorage.getItem('userRole'));
  console.log('Received type prop:', type); 
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [title, setTitle] = useState(state?.title || '');
  //const [body, setBody] = useState(state?.body || '');
  const [bodyHTML, setBodyHTML] = useState(state?.body || '');
  // const [images, setImages] = useState(state?.imageUrls || []);
  // const [existingImageUrls, setExistingImageUrls] = useState(state?.imageUrls || []);
  // const [newImages, setNewImages] = useState([]);

  // Single state for all images
  const [allImages, setAllImages] = useState(
    (state?.imageUrls || []).map(url => ({ type: 'url', data: url }))
  );

  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) {
      setError('The Title is required');
      return;
    }

    // Format body to ensure proper Markdown list syntax
    // const lines = body.split('\n').map(line => line.trim()).filter(line => line !== '');
    // const formattedBody = lines.map(line => {
    //   if (!/^[-*]\s+/.test(line)) {
    //     return ` ${line}`;
    //   }
    //   return line;
    // }).join('\n');
    // Create FormData object to send images and text
    const formData = new FormData();
    formData.append('title', title);
    formData.append('body', bodyHTML);
    formData.append('type', type);
    
    // setImages([...existingImageUrls, ...newImages]);
    // images.forEach((image) => {
    //   formData.append('images', image);
    // });
    // Add only new files to FormData (existing URLs don't need to be re-uploaded)

    formData.append(
      'existingImageUrls',
      JSON.stringify(allImages.filter(i => i.type === 'url').map(i => i.data))
    );

    allImages.forEach((image) => {
      if (image.type === 'file') {
        formData.append('images', image.data);
      }
    });

        console.log('FormData contents:');
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value instanceof File ? `${value.name} (${value.size} bytes)` : value);
    }
    try {
      await updatePolicy(id, formData);
      handleNavigation();
    } catch (err) {
      setError('Failed to update policy. Try again.');
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => {
      if (file.size > 5 * 1024 * 1024) {
        setError('Each image must be less than 5MB');
        return false;
      }
      if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
        setError('Only JPEG, PNG, or GIF images are allowed');
        return false;
      }
      return true;
    });
    
    // Add new files to allImages
    setAllImages(prev => [
      ...prev,
      ...validFiles.map(file => ({ type: 'file', data: file }))
    ]);
    
    if (validFiles.length === files.length) {
      setError('');
    }
  };

  const handleNavigation = () => {
  // const route = pTitle.toLowerCase().includes('office') 
  //   ? '/office-policies' 
  //   : '/hr-handbook';
  navigate('/policies');
  };

const handleDeleteImage = (indexToDelete) => {
  setAllImages(allImages.filter((_, index) => index !== indexToDelete));
  setError(''); // Clear any error on delete
};

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Card sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h5" color="primary" gutterBottom>
          {pTitle}
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mt: 2,
          }}
        >
          <TextField
            fullWidth
            label="Policy Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          {/* body */}
          <Typography variant="body1" color="textSecondary">Policy Body</Typography>
          <EditorConvertToHTML value={bodyHTML} onChange={setBodyHTML} />
          <Box
            sx={{
              border: '2px dashed #90caf9', // primary200
              borderRadius: '8px',
              padding: 2,
              backgroundColor: '#f0f5ff', // primaryLight
              transition: 'all 0.3s ease',
              '&:hover': {
                borderColor: '#2196f3', // primaryMain
                backgroundColor: '#e3f2fd'
              }
            }}
          >
            <Typography variant="body1" color="#1565c0" gutterBottom> {/* primary800 */}
              Upload Images (Optional)
            </Typography>
            <Button
              variant="contained"
              startIcon={<CloudUpload />}
              onClick={handleButtonClick}
              sx={{
                backgroundColor: '#2196f3', // primaryMain
                '&:hover': {
                  backgroundColor: '#1e88e5' // primaryDark
                },
                mb: 2
              }}
            >
              Choose Images
            </Button>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              ref={fileInputRef}
              style={{ display: 'none' }}
            />
            {allImages.length > 0 && (
              <Box sx={{ mt: 1 }}>
                <Typography variant="body2" color="#3d52a0">
                  Selected Images:
                </Typography>
                  {allImages.map((image, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mt: 0.5
                      }}
                    >
                    <Typography variant="body2" color="textSecondary">
                      {image.type === 'url' ? image.data : image.data.name}
                    </Typography>
                    <IconButton
                      onClick={() => handleDeleteImage(index)}
                      size="small"
                      sx={{ color: '#f44336' }}
                    >
                    <Delete fontSize="small" />
                      </IconButton>
                </Box>
              ))}
            </Box>
          )}
          </Box>
          {error && (
            <Typography color="error" sx={{ flexShrink: 0 }}>
              {error}
            </Typography>
          )}
        </Box>
      </CardContent>
      <Box
        sx={{
          p: 2,
          borderTop: '1px solid #ccc',
          display: 'flex',
          justifyContent: 'flex-end',
          backgroundColor: 'var(--card-bg, white)',
        }}
      >
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: '#2196f3',
            '&:hover': { backgroundColor: '#1e88e5' },
          }}
          onClick={handleSubmit}
        >
          Update Policy
        </Button>
      </Box>
    </Card>
  );
};

export default UpdatePolicyForm;